export function formatDisplayDate(value: string): string {
	const date = new Date(value)

	if (Number.isNaN(date.getTime())) {
		return '-'
	}

	return new Intl.DateTimeFormat('en-US', {
		month: 'short',
		day: 'numeric',
		year: 'numeric',
	}).format(date)
}
